import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import {
  BackgroundShade,
  LogoMinWidth,
} from '@digital-platform/rs-shared/domain';

const originalSize = {
  width: 303,
  height: 97,
  padding: 32,
  strokeW: 303,
  strokeH: 97,
};

const rOriginalSize = {
  width: 400,
  height: 336,
};

@Component({
  selector: 'digital-platform-logo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logo.component.html',
})
export class LogoComponent implements OnInit {
  @Input() public width?: LogoMinWidth;
  @Input() public bgShade?: BackgroundShade;
  @Input() public simpleLogo?: boolean;
  public showComplexLogo = true;
  public nameColorCls?: string;
  public computedWidth?: LogoMinWidth;
  public computedHeight?: number;
  public containerStyle?: string;
  public strokeW?: number;
  public strokeH?: number;
  public rComputedWidth?: number;
  public rComputedHeight?: number;

  ngOnInit() {
    this.showComplexLogo = !this.simpleLogo;

    this.nameColorCls = this.bgShade === 'dark' ? 'fill-light' : 'fill-primary';

    // Compute the values by percent.
    this.computedWidth = Math.max(this.width ?? originalSize.width, 110);
    const percent = this.computedWidth / originalSize.width;
    this.computedHeight = Math.round(originalSize.height * percent);
    this.strokeW = Math.round(originalSize.strokeW * percent);
    this.strokeH = Math.round(originalSize.strokeH * percent);
    const padding = Math.round(originalSize.padding * percent);
    this.containerStyle = `padding: ${padding}px;`;
    // Values for the simple "R"
    this.rComputedWidth = this.width ?? rOriginalSize.width;
    const rPercent = this.computedWidth / originalSize.width;
    this.rComputedHeight = Math.round(rOriginalSize.height * rPercent);
  }
}
